export class FirmaObj {
  firmaDati: string;
    
}